<!-- Debug-layout swap spinner -->
@if (debugToggle.transitioning()) {
<div class="flex justify-center items-center h-40">
  <i class="pi pi-spin pi-spinner text-2xl"></i>
  <p class="ml-2">Switching layout...</p>
</div>
}

<!-- Debug layout (non-prod only, Ctrl+Alt+D) -->
@if (!envService.isProduction() && debugToggle.effectiveEnabled() && !debugToggle.transitioning()) {
<div class="mx-4 md:mx-[24px] text-xl md:text-[22px] xlplus:text-2xl font-semibold">
  XBRL Files
</div>
<app-xbrl-files-debug-layout [host]="this" />
}

<!-- Standard layout: hide when debug is active -->
@if (!(!envService.isProduction() && debugToggle.effectiveEnabled()) && !debugToggle.transitioning()) {
<div class="mx-4 md:mx-[24px] text-xl md:text-[22px] xlplus:text-2xl font-semibold">
  XBRL Files
</div>
<div class="mx-4 md:mx-[24px] mt-4 md:mt-[24px] flex flex-wrap gap-3 items-center">
  <p-iconfield class="flex w-full sm:w-auto sm:!w-[280px] sm:!mr-2 xlplus:!w-[300px]">
    <input
      type="text"
      pInputText
      placeholder="Filename or Client Company"
      class="!w-full sm:!w-[290px] xlplus:!w-[310px] !h-[36px] xlplus:!h-[42px] !text-sm xlplus:!text-base"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchChange($event)"
    />
    <p-inputicon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6066 10.4839L11.5758 10.5234H11.6259H12.1353C12.3289 10.5234 12.5133 10.599 12.6493 10.735L15.7651 13.8502C16.0463 14.1344 16.0463 14.594 15.762 14.8782L14.8776 15.7624L14.8775 15.7625C14.5964 16.0466 14.1369 16.0467 13.8526 15.7624L10.7368 12.6471C10.6008 12.5112 10.5252 12.3268 10.5252 12.1332V11.6239V11.5738L10.4857 11.6046C9.38668 12.4638 8.00433 12.9743 6.50048 12.9743C2.92307 12.9743 0.0244141 10.0762 0.0244141 6.49937C0.0244141 2.92258 2.92307 0.0244141 6.50048 0.0244141C10.0779 0.0244141 12.9765 2.92258 12.9765 6.49937C12.9765 8.00296 12.4659 9.38507 11.6066 10.4839ZM2.47577 6.49937C2.47577 8.72515 4.27747 10.5234 6.50048 10.5234C8.72663 10.5234 10.5252 8.722 10.5252 6.49937C10.5252 4.27358 8.72348 2.47534 6.50048 2.47534C4.27432 2.47534 2.47577 4.27673 2.47577 6.49937Z"
          fill="black"
          stroke="#CBCBCB"
          stroke-width="0.0488281"
        />
      </svg>
    </p-inputicon>
  </p-iconfield>
  <p-select
    [options]="conversionStatuses"
    [(ngModel)]="selectedStatus"
    (ngModelChange)="onStatusChange()"
    optionLabel="status"
    placeholder="All statuses"
    class="!w-full sm:!w-auto !text-sm xlplus:!text-base !h-[36px] xlplus:!h-[42px]"
    optionLabel="label"
    optionValue="value"
    styleClass="!w-full sm:!w-auto"
  />
  <p-datepicker
    [(ngModel)]="selectedDate"
    (ngModelChange)="onDateChange($event)"
    selectionMode="range"
    dateFormat="dd.mm.yy"
    [iconDisplay]="'input'"
    [showIcon]="true"
    inputId="conversionDateRange"
    placeholder="Conversion date range"
    class="!w-full sm:!w-[230px] xlplus:!w-[250px] !h-[36px] xlplus:!h-[42px]"
    inputStyleClass="!text-sm xlplus:!text-base !w-full"
  />
  <p-datepicker
    [(ngModel)]="selectedModifiedDate"
    (ngModelChange)="onModifiedDateChange($event)"
    selectionMode="range"
    dateFormat="dd.mm.yy"
    [iconDisplay]="'input'"
    [showIcon]="true"
    inputId="modifiedDateRange"
    placeholder="Modified date range"
    class="!w-full sm:!w-[230px] xlplus:!w-[250px] !h-[36px] xlplus:!h-[42px]"
    inputStyleClass="!text-sm xlplus:!text-base !w-full"
  />
  <p
    class="cursor-pointer underline font-lato text-sm xlplus:text-base font-normal text-[#83858A]"
    (click)="clearFilters()"
  >
    Clear Filters
  </p>
  <!-- Pushed to the far right of whichever wrapped row it lands on (ml-auto),
       and right-justified so the text hugs that edge. -->
  <p class="hidden md:block text-[#4B4848] ml-auto text-right">
    (<span class="!text-red-500">*</span>)Optional: Suggestions to refine data
  </p>
</div>

<!-- Table wrapper -->
<div class="mx-4 md:mx-[24px] mt-4 md:mt-[20px]">
  <!-- The minimum width goes on the inner <table> (`tableStyleClass`), NOT on the root (`styleClass`):
     PrimeNG's table container scrolls sideways by itself, so a narrow window scrolls only the table.
     A min-width on the root instead widens the whole page, and the title, filters and the
     Add/Search controls scroll away with it. -->
<p-table
    [value]="fullData()"
    [paginator]="false"
    [scrollable]="true"
    sortField="lastupdated"
    [sortOrder]="-1"
    [customSort]="true"
    (onSort)="onSort($event)"
    styleClass="!text-sm xlplus:!text-base"
  tableStyleClass="min-w-[800px]"
  >
    <ng-template pTemplate="header">
      <tr>
        <!-- Column-width contract for this table: every fixed-content column
             (No., Status, the action gutter, both date columns) carries a hard
             `!w-[…]`, and the two ellipsis columns carry `!min-w-[…]` only.
             Auto-layout hands leftover table width to the columns WITHOUT a
             specified width, so this routes the slack into Filename/Client Company —
             where a wider column means less truncation — instead of letting it
             inflate "No." to several hundred px. Turning a `!min-w-` here into
             a `!w-` re-breaks that. -->
        <th class="!bg-[#e7e7e7] !w-[50px]">No.</th>
        <th
          pSortableColumn="xbrlFileName"
          class="!bg-[#e7e7e7] !min-w-[270px] xlplus:!min-w-[320px] whitespace-nowrap"
        >
          Filename
          <p-sortIcon
            class="sort-icon-small sort-icon-large"
            field="xbrlFileName"
          ></p-sortIcon>
        </th>
        <th
          pSortableColumn="company"
          class="!bg-[#e7e7e7] !min-w-[180px] xlplus:!min-w-[220px] 2xl:!min-w-[300px] whitespace-nowrap"
        >
          Client Company
          <p-sortIcon
            class="sort-icon-small sort-icon-large"
            field="company"
          ></p-sortIcon>
        </th>
        <th class="!bg-[#e7e7e7] !w-[130px] whitespace-nowrap">Status</th>
        <!-- `whitespace-nowrap` on the date columns is what actually holds them
             open. The declared `!w-[…]` is only a PREFERRED width — with
             wrapping allowed the column's min-content collapses to the longest
             single word ("Conversion", "August"), so a squeezed table shrinks
             past it and breaks "06 August 2026" over two lines. Forbidding the
             wrap raises min-content to the full string, which pins the floor and
             pushes the overflow into the table's horizontal scroll instead —
             the behaviour wanted on mobile. It inherits, so one class per cell
             covers both the date line and the time line beneath it. -->
        <th
          pSortableColumn="conversionDate"
          class="!bg-[#e7e7e7] !w-[220px] xlplus:!w-[250px] whitespace-nowrap"
        >
          Created Date
          <p-sortIcon
            class="sort-icon-small sort-icon-large"
            field="conversionDate"
          ></p-sortIcon>
        </th>
        <!-- Not sortable: the backend does not support sorting on createdBy /
             updatedBy, and a header that sent `sortBy=createdBy` would silently
             fall back to the default order. -->
        <th class="!bg-[#e7e7e7] !w-[250px] xlplus:!w-[285px] !min-w-[250px] xlplus:!min-w-[285px] whitespace-nowrap">Created By</th>
        <th
          pSortableColumn="lastupdated"
          class="!bg-[#e7e7e7] !w-[220px] xlplus:!w-[250px] whitespace-nowrap"
        >
          Last Modified
          <p-sortIcon
            class="sort-icon-small sort-icon-large"
            field="lastupdated"
          ></p-sortIcon>
        </th>
        <th class="!bg-[#e7e7e7] !w-[250px] xlplus:!w-[285px] !min-w-[250px] xlplus:!min-w-[285px] whitespace-nowrap">Last Modified By</th>
        <th class="!bg-[#e7e7e7] !w-[56px]"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr data-testid="xbrl-file-row" [attr.data-conversion-id]="item.id">
        <td>
          {{ first() + rowIndex + 1 }}
        </td>
        <!-- Width-based ellipsis over TWO lines, not a character count.
             `!max-w-0` on the <td> is the load-bearing bit: a filename is one
             unbroken token, so its min-content width is the whole string and an
             auto-layout table would widen the column to fit rather than clamp.
             Pinning the cell's preferred width to 0 hands column sizing to the
             <th> instead, and `w-full` then makes the span fill exactly that
             column — so the cut lands at the real column edge at any breakpoint.

             No `block`: `line-clamp-2` sets `display: -webkit-box`, and the two
             would fight over `display` by stylesheet order.

             `break-all` is NOT cosmetic, and it is deliberately NOT
             `break-words`. `-webkit-line-clamp` renders its ellipsis at a LINE
             BREAK, and a filename offers none — so without a break rule the
             token overflows sideways on a single line and gets hard-cut with no
             ellipsis at all. `break-words` (overflow-wrap: break-word) would
             cover that case but breaks a token ONLY when it cannot fit, so a
             filename containing spaces still wraps at its spaces and the cut
             lands on a word boundary with a ragged gap before the ellipsis. The
             PO asked for the cut by CHARACTER: `break-all` (word-break:
             break-all) makes every character a break opportunity, so both lines
             fill to the column edge. Covered by
             overflow-tooltip.directive.spec.ts. -->
        <td class="!max-w-0">
          <span
            appOverflowTooltip
            #fileNameClamp="overflowTooltip"
            class="w-full line-clamp-2 break-all cursor-pointer"
            tooltipPosition="top"
            tooltipStyleClass="top-tooltip"
            [pTooltip]="item.fileName"
            [tooltipDisabled]="!fileNameClamp.isOverflowing()"
          >
            {{ item.fileName }}
          </span>
        </td>
        <td class="!max-w-0" data-testid="xbrl-file-company">
          @if (item.company) {
          <!-- Real anchor: routerLink renders an href, so right-click "Open in
               New Tab", middle-click and Ctrl/Cmd+click work natively while a
               plain left-click stays SPA navigation. routerLink is set to null
               for non-terminal rows so no href (and no new-tab option) renders;
               pointer-events:none is the second guard. -->
          <!-- The tooltip lives on the wrapper, not the anchor: a non-terminal
               row sets `pointer-events: none` on the anchor, which would swallow
               the hover the tooltip needs. The wrapper also owns the ellipsis so
               the inline anchor can keep its own pointer/cursor behaviour. -->
          <span
            appOverflowTooltip
            #companyClamp="overflowTooltip"
            class="w-full line-clamp-2 break-all"
            tooltipPosition="top"
            tooltipStyleClass="top-tooltip"
            [pTooltip]="item.company | titlecase"
            [tooltipDisabled]="!companyClamp.isOverflowing()"
          >
            <a
              class="text-blue-500"
              [routerLink]="isCompanyClickable(item.status) ? ['/mbrs/filing'] : null"
              [queryParams]="{ id: item.id, companyName: item.company, fileName: item.fileName }"
              [state]="filingEntryState(item.phase)"
              [ngStyle]="{
                color: isCompanyClickable(item.status) ? '#0b8ebb' : '#5F5B5B',
                'pointer-events': isCompanyClickable(item.status) ? 'auto' : 'none',
                cursor: isCompanyClickable(item.status) ? 'pointer' : 'not-allowed'
              }"
            >
              {{ item.company | titlecase }}
            </a>
          </span>
          } @else {
          <p>-</p>
          }
        </td>
        <td>
          @if (item.status === MbrsStatusEnum.PendingValidation) {
          <!-- AS-842: PendingValidation shows a skeleton while the frontend
               silently validates the conversion. The chip renders once the
               resolver emits the terminal status. -->
          <p-skeleton width="105px" height="25px"></p-skeleton>
          } @else {
          <div
            [ngClass]="conversionListingService.getStatusClass(item.status)"
            class="h-[25px] w-[105px] font-lato font-bold text-xs xlplus:text-sm text-center px-3 py-1 rounded flex items-center space-x-1 justify-center"
          >
            <span
              >{{ conversionListingService.getDisplayBaseStatus(item.status)
              }}@if (conversionListingService.hasWarningAsterisk(item.status)) {<span
                  class="!text-red-500"
                  >*</span
                >}</span
            >
          </div>
          }
        </td>
        <td class="whitespace-nowrap">
          <div class="text-[16px]">
            {{ item.conversionDate | date : "dd MMMM yyyy" }}
          </div>
          <div class="text-[14px] text-[#83858A]">
            {{ item.conversionDate | date : "shortTime" }}
          </div>
        </td>
        <!-- The backend returns user ids, not names (see the "Showing a name
             instead of an id" open item in its hand-over). Show the id in the
             normal text colour until a display name is available; a dash when
             it is absent. -->
        <td class="!min-w-[250px] xlplus:!min-w-[285px]" data-testid="xbrl-file-created-by">
          <span class="w-full line-clamp-2 break-all">{{ item.createdBy || "-" }}</span>
        </td>
        <td class="whitespace-nowrap">
          <div class="text-[16px]">
            {{ item.updatedDate | date : "dd MMMM yyyy" }}
          </div>
          <div class="text-[14px] text-[#83858A]">
            {{ item.updatedDate | date : "shortTime" }}
          </div>
        </td>
        <td class="!min-w-[250px] xlplus:!min-w-[285px]" data-testid="xbrl-file-modified-by">
          <span class="w-full line-clamp-2 break-all">{{ item.updatedBy || "-" }}</span>
        </td>
        <td class="cursor-pointer p-0">
          @if (isMoreActionButtonVisible(item.status)) {
          <p
            data-testid="xbrl-row-menu"
            (click)="onTriggerOverlay(rowIndex)"
            cdkOverlayOrigin
            #trigger="cdkOverlayOrigin"
            class="px-[4px] py-[4px] w-[24px] h-[24px] flex justify-center rounded-md text-black hover:!bg-[#E0F2FE]"
          >
            <svg
              width="4"
              height="14"
              viewBox="0 0 4 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.99967 2.66699C2.18377 2.66699 2.33301 2.51775 2.33301 2.33366C2.33301 2.14956 2.18377 2.00033 1.99967 2.00033C1.81558 2.00033 1.66634 2.14956 1.66634 2.33366C1.66634 2.51775 1.81558 2.66699 1.99967 2.66699ZM0.333008 2.33366C0.333008 1.41318 1.0792 0.666992 1.99967 0.666992C2.92015 0.666992 3.66634 1.41318 3.66634 2.33366C3.66634 3.25413 2.92015 4.00033 1.99967 4.00033C1.0792 4.00033 0.333008 3.25413 0.333008 2.33366ZM1.99967 7.33366C2.18377 7.33366 2.33301 7.18442 2.33301 7.00033C2.33301 6.81623 2.18377 6.66699 1.99967 6.66699C1.81558 6.66699 1.66634 6.81623 1.66634 7.00033C1.66634 7.18442 1.81558 7.33366 1.99967 7.33366ZM0.333008 7.00033C0.333008 6.07985 1.0792 5.33366 1.99967 5.33366C2.92015 5.33366 3.66634 6.07985 3.66634 7.00033C3.66634 7.9208 2.92015 8.66699 1.99967 8.66699C1.0792 8.66699 0.333008 7.9208 0.333008 7.00033ZM2.33301 11.667C2.33301 11.8511 2.18377 12.0003 1.99967 12.0003C1.81558 12.0003 1.66634 11.8511 1.66634 11.667C1.66634 11.4829 1.81558 11.3337 1.99967 11.3337C2.18377 11.3337 2.33301 11.4829 2.33301 11.667ZM1.99967 10.0003C1.0792 10.0003 0.333008 10.7465 0.333008 11.667C0.333008 12.5875 1.0792 13.3337 1.99967 13.3337C2.92015 13.3337 3.66634 12.5875 3.66634 11.667C3.66634 10.7465 2.92015 10.0003 1.99967 10.0003Z"
                fill="currentColor"
              />
            </svg>
          </p>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="openedOverlayId() === rowIndex"
            [cdkConnectedOverlayPositions]="[
              { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 4 },
              { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -4 }
            ]"
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayBackdropClass]="
              'cdk-overlay-transparent-backdrop'
            "
            (backdropClick)="openedOverlayId.set(null)"
            (detach)="openedOverlayId.set(null)"
          >
            <div
              class="bg-white w-[139px] h-auto shadow-md rounded-md pt-[8px] pb-[8px]"
            >
              <div
                class="h-[33px] flex items-center hover:bg-[#E0F2FE] cursor-pointer"
                data-testid="xbrl-row-download"
                (click)="downloadXbrlFile(item)"
                [class.opacity-50]="!isDownloadable(item.status) || isDownloading(item.id)"
                [style.pointer-events]="
                  isDownloadable(item.status) && !isDownloading(item.id)
                    ? 'auto'
                    : 'none'
                "
              >
                <svg
                  class="w-[13px] h-[13px] xlplus:w-[16px] xlplus:h-[16px] mr-[16px] ml-[16px]"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 10.5L3 6.125L4.4 4.85625L7 7.13125V0H9V7.13125L11.6 4.85625L13 6.125L8 10.5ZM2 14C1.45 14 0.979333 13.8288 0.588 13.4864C0.196666 13.144 0.000666667 12.7318 0 12.25V9.625H2V12.25H14V9.625H16V12.25C16 12.7312 15.8043 13.1434 15.413 13.4864C15.0217 13.8294 14.5507 14.0006 14 14H2Z"
                    fill="#5F5B5B"
                  />
                </svg>

                <span
                  class="text-taxpod-gray text-sm xlplus:text-base font-normal font-lato"
                  >Download</span
                >
              </div>
              <div
                class="h-[33px] flex items-center hover:bg-[#E0F2FE] cursor-pointer"
                (click)="deleteXbrlFile(item)"
              >
                <svg
                  class="w-[12px] h-[13px] xlplus:w-[15px] xlplus:h-[16px] mr-[16px] ml-[16px]"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.46967 1.66756C5.61032 1.53117 5.80109 1.45455 6 1.45455H9C9.19891 1.45455 9.38968 1.53117 9.53033 1.66756C9.67098 1.80395 9.75 1.98893 9.75 2.18182V2.90909H5.25V2.18182C5.25 1.98893 5.32902 1.80395 5.46967 1.66756ZM3.75 2.90909V2.18182C3.75 1.60316 3.98705 1.04821 4.40901 0.63904C4.83097 0.229869 5.40326 0 6 0H9C9.59674 0 10.169 0.229869 10.591 0.63904C11.0129 1.04821 11.25 1.60316 11.25 2.18182V2.90909H12.75H14.25C14.6642 2.90909 15 3.2347 15 3.63636C15 4.03803 14.6642 4.36364 14.25 4.36364H13.5V13.8182C13.5 14.3968 13.2629 14.9518 12.841 15.361C12.419 15.7701 11.8467 16 11.25 16H3.75C3.15326 16 2.58097 15.7701 2.15901 15.361C1.73705 14.9518 1.5 14.3968 1.5 13.8182V4.36364H0.75C0.335786 4.36364 0 4.03803 0 3.63636C0 3.2347 0.335786 2.90909 0.75 2.90909H2.25H3.75ZM4.5 4.36364H10.5H12V13.8182C12 14.0111 11.921 14.1961 11.7803 14.3324C11.6397 14.4688 11.4489 14.5455 11.25 14.5455H3.75C3.55109 14.5455 3.36032 14.4688 3.21967 14.3324C3.07902 14.1961 3 14.0111 3 13.8182V4.36364H4.5ZM6 6.54545C6.41421 6.54545 6.75 6.87107 6.75 7.27273V11.6364C6.75 12.038 6.41421 12.3636 6 12.3636C5.58579 12.3636 5.25 12.038 5.25 11.6364V7.27273C5.25 6.87107 5.58579 6.54545 6 6.54545ZM9.75 11.6364V7.27273C9.75 6.87107 9.41421 6.54545 9 6.54545C8.58579 6.54545 8.25 6.87107 8.25 7.27273V11.6364C8.25 12.038 8.58579 12.3636 9 12.3636C9.41421 12.3636 9.75 12.038 9.75 11.6364Z"
                    fill="#E73A3A"
                  />
                </svg>
                <span
                  class="text-[#E73A3A] text-sm xlplus:text-base font-normal font-lato"
                  >Delete</span
                >
              </div>
            </div>
          </ng-template>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

@if (isTableLoading()) {
<div class="mx-4 md:mx-[24px]">
  <p-skeleton width="100%" height="400px"></p-skeleton>
</div>
} @else if (fullData().length === 0) {
<div
  class="flex justify-center bg-white items-center h-[230px] mx-4 md:mx-[24px] xlplus:h-[480px]"
>
  <div class="px-4">
    <svg
      width="182"
      height="135"
      viewBox="0 0 182 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="mx-auto"
    >
      <path
        d="M34.1108 133.326C52.8256 133.326 67.997 130.991 67.997 128.112C67.997 125.233 52.8256 122.899 34.1108 122.899C15.396 122.899 0.224609 125.233 0.224609 128.112C0.224609 130.991 15.396 133.326 34.1108 133.326Z"
        fill="#DFDFEB"
      />
      <path
        d="M89.4965 134.368C123.306 134.368 150.714 132.034 150.714 129.155C150.714 126.276 123.306 123.942 89.4965 123.942C55.6872 123.942 28.2793 126.276 28.2793 129.155C28.2793 132.034 55.6872 134.368 89.4965 134.368Z"
        fill="#DFDFEB"
      />
      <path
        d="M72.8426 0.636197C66.5212 0.808419 61.2908 5.87173 60.9272 12.1852C60.7132 15.8976 62.1519 19.2757 64.5732 21.659C64.931 22.0111 65.0972 22.5131 65.0136 23.0081L64.1044 28.3887L69.699 25.129C70.0176 24.9433 70.3929 24.8751 70.7546 24.9481C72.1222 25.224 73.571 25.2747 75.0646 25.0486C80.5912 24.2114 84.9031 19.6361 85.4128 14.0695C86.0914 6.65055 80.1658 0.436867 72.8426 0.636197Z"
        fill="#FF5353"
      />
      <g clip-path="url(#clip0_659_12884)">
        <path
          d="M75.2305 15.6771H72.2213C72.2213 12.6679 73.8262 11.6648 74.9296 11.063C75.3308 10.8624 75.6317 10.6617 75.8323 10.4611C76.3339 9.95958 76.1333 9.25742 76.033 9.05681C75.732 8.35465 75.0299 7.65249 73.7259 7.65249C71.6194 7.65249 71.2182 9.55835 71.2182 9.95958L68.209 9.55835C68.4096 7.85311 69.9142 4.64325 73.7259 4.64325C76.033 4.64325 78.0391 5.94726 78.8416 7.85311C79.5437 9.55835 79.2428 11.3639 78.0391 12.5676C77.5376 13.0691 76.9357 13.3701 76.4342 13.671C75.5314 14.1725 75.2305 14.6741 75.2305 15.6771ZM75.732 18.6864C75.7381 18.9535 75.6907 19.2192 75.5926 19.4678C75.4946 19.7164 75.3479 19.9429 75.1611 20.134C74.9743 20.3251 74.7512 20.477 74.5049 20.5807C74.2586 20.6844 73.9941 20.7378 73.7269 20.7379C73.4597 20.738 73.1951 20.6846 72.9488 20.5811C72.7025 20.4775 72.4793 20.3257 72.2924 20.1347C72.1055 19.9437 71.9587 19.7173 71.8605 19.4687C71.7624 19.2202 71.7148 18.9546 71.7207 18.6874C71.7323 18.1632 71.9487 17.6644 72.3234 17.2977C72.6982 16.9311 73.2016 16.7257 73.7259 16.7256C74.2502 16.7254 74.7537 16.9306 75.1287 17.297C75.5036 17.6635 75.7202 18.1622 75.732 18.6864Z"
          fill="white"
        />
      </g>
      <path
        d="M115.613 38.9346C115.613 38.9346 114.061 45.4241 105.282 53.3422C105.282 53.3422 104.445 52.157 106.319 47.59C108.193 43.0232 115.245 37.3154 115.613 38.9346Z"
        fill="#8BB8F9"
      />
      <path
        d="M115.611 38.9328C115.611 38.9328 107.859 43.7598 105.281 53.3404C105.281 53.3404 104.689 56.6448 105.645 59.6019"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M95.348 42.9583C95.348 42.9583 97.5285 41.5158 94.203 37.3509C91.0441 33.3943 87.6609 29.8114 80.707 28.1323C80.707 28.1323 82.2191 37.7939 86.656 40.3584C91.0932 42.9226 95.348 42.9583 95.348 42.9583Z"
        fill="#8BB8F9"
      />
      <path
        d="M77.8298 48.8678C77.8298 48.8678 85.0646 50.9386 97.7748 47.5835C97.7748 47.5835 97.0859 46.2475 91.5528 45.4584C86.0201 44.6694 76.4498 47.7059 77.8298 48.8678Z"
        fill="#8BB8F9"
      />
      <path
        d="M77.8301 48.869C77.8301 48.869 86.9319 44.773 97.7751 47.5847C97.7751 47.5847 98.8862 47.9397 99.9377 49.5493"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M83.4847 55.9057C83.4847 55.9057 91.0049 61.5775 103.715 58.2224C103.715 58.2224 101.576 53.6891 96.0433 52.9001C90.5103 52.111 82.105 54.7438 83.4847 55.9057Z"
        fill="#8BB8F9"
      />
      <path
        d="M83.4844 55.9056C83.4844 55.9056 92.2003 52.4994 103.715 58.2223C103.715 58.2223 105.067 58.9309 106.118 60.5406"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M111.676 32.4429C111.676 32.4429 114.011 32.3137 108.021 37.1825C102.364 41.7795 103.041 41.8618 103.041 41.8618C103.041 41.8618 105.541 34.6004 111.676 32.4429Z"
        fill="white"
      />
      <path
        d="M98.9961 44.1144C98.9961 44.1144 100.684 44.8926 103.989 42.2279C107.295 39.5633 108.867 33.2533 111.676 32.4426C111.676 32.4426 104.647 34.2257 98.9961 44.1144Z"
        fill="#8BB8F9"
      />
      <path
        d="M108.941 66.7791C105.875 59.4609 101.503 51.09 95.3496 42.9583C95.3496 42.9583 93.8538 40.715 88.5357 34.8074C83.2177 28.8999 80.709 28.1323 80.709 28.1323"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M110.84 32.7316C110.84 32.7316 104.103 35.1711 98.9952 44.1155C97.7577 46.2823 98.9531 48.1365 99.9366 49.5487"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M179.042 117.019C179.042 117.019 172.509 118.98 161.607 111.915C161.607 111.915 162.323 110.017 167.254 109.711C172.185 109.406 180.352 115.492 179.042 117.019Z"
        fill="#8BB8F9"
      />
      <path
        d="M178.798 116.539C178.798 116.539 171.621 110.892 161.735 111.728C161.735 111.728 158.426 112.295 155.971 114.201"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M164.821 102.458C164.821 102.458 166.92 104.017 169.704 99.4732C172.35 95.1565 174.568 90.756 173.781 83.6454C173.781 83.6454 165.21 88.3548 164.309 93.3996C163.407 98.4447 164.821 102.458 164.821 102.458Z"
        fill="#8BB8F9"
      />
      <path
        d="M181.672 110.575C181.672 110.575 183.044 112.469 175.709 110.065C168.783 107.795 169.08 108.408 169.08 108.408C169.08 108.408 176.539 106.582 181.672 110.575Z"
        fill="white"
      />
      <path
        d="M164.996 106.225C164.996 106.225 165.254 108.065 169.284 109.404C173.313 110.742 179.471 108.652 181.672 110.575C181.672 110.575 176.369 105.628 164.996 106.225Z"
        fill="#8BB8F9"
      />
      <path
        d="M147.047 123.344C152.885 117.97 159.268 111.011 164.821 102.458C164.821 102.458 166.422 100.288 170.167 93.2768C173.913 86.2658 173.781 83.6454 173.781 83.6454"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M180.978 110.027C180.978 110.027 175.282 105.681 164.996 106.224C162.504 106.355 161.376 107.568 159.508 109.898"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M111.101 51.9979C113.1 51.9979 115.036 51.2962 116.571 50.0154L120.831 46.4613C122.363 45.1824 124.184 44.497 126.049 44.497H147.187C149.105 44.497 150.66 46.0521 150.66 47.9701V51.9976V124.495C150.66 127.805 147.977 130.488 144.667 130.488H39.2962C36.7218 130.488 34.6348 128.401 34.6348 125.827V56.6594C34.6348 54.085 36.7218 51.9979 39.2962 51.9979H111.101Z"
        fill="#00B0ED"
      />
      <path
        d="M34.6347 126.218C34.6347 126.218 41.8058 112.767 42.523 111.222L62.1214 71.2945C62.6141 70.2335 63.6774 69.5548 64.8472 69.5548H137.677C140.324 69.5548 144.154 68.1668 146.186 66.4704L149.125 64.0182C150.658 62.7393 152.479 62.0539 154.344 62.0539H174.46C176.601 62.0539 178.055 64.229 177.237 66.2079L152.913 125.04C151.549 128.338 148.332 130.489 144.764 130.489H35.95C35.2407 130.489 34.5856 129.881 34.5859 129.172L34.6347 126.218Z"
        fill="#B7DFF4"
      />
      <path
        d="M76.1078 82.9862H100.88C101.556 82.9862 102.184 82.6463 102.547 82.0849C103.384 80.7898 102.439 79.0947 100.88 79.0947H76.1078C75.4323 79.0947 74.8037 79.4346 74.4411 79.9956C73.6039 81.2911 74.5489 82.9862 76.1078 82.9862Z"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M122.448 102.198L103.16 113.689"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M106.678 101.645L118.797 113.76"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M115.961 118.419C123.68 116.284 128.631 109.825 127.017 103.992C125.404 98.1601 117.838 95.1631 110.118 97.2985C102.399 99.4339 97.4485 105.893 99.0618 111.725C100.675 117.558 108.241 120.555 115.961 118.419Z"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <clipPath id="clip0_659_12884">
          <rect
            width="16.0492"
            height="16.0493"
            fill="white"
            transform="translate(66.2031 4.64325)"
          />
        </clipPath>
      </defs>
    </svg>
    <p
      class="font-lato text-center text-taxpod-gray text-sm xlplus:text-base font-bold mt-6"
    >
      No data Available Yet
    </p>
    <p
      class="font-lato text-center text-taxpod-gray text-xs xlplus:text-sm font-normal"
    >
      Use the XBRL Conversion Tool in the
      <a
        routerLink="/mbrs/dashboard"
        class="text-[#0b8ebb] font-bold cursor-pointer"
        >Dashboard </a
      >to <br />start converting your files.
    </p>
  </div>
</div>
}

<!-- Footer with paginator and buttons -->
<div class="flex flex-col sm:flex-row justify-between items-center mt-4 gap-3 sm:h-[52px] mx-4 md:mx-[24px] pb-4 md:pb-0">
  <div>
    <p
      class="font-lato font-normal text-sm xlplus:text-base text-taxpod-gray-light text-center sm:text-left"
    >
      Showing
      <span class="font-semibold">
        {{ first() + 1 }} - {{ min(first() + rows(), totalRecords()) }}
      </span>
      of <span class="font-semibold">{{ totalRecords() }} Items</span>
    </p>
  </div>
  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="first()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    [pageLinkSize]="3"
    [showFirstLastIcon]="true"
    styleClass="!text-sm xlplus:!text-base !font-bold !text-taxpod-gray !bg-transparent"
  >
  </p-paginator>
</div>
}

<interactive-toast [key]="'process_mbrs_data'"></interactive-toast>
<app-delete-conversion
  [(isArchiveDialogOpen)]="isArchiveDialogOpen"
  [conversionData]="conversionData"
  (archiveConversionCompleted)="onStatusChange()"
></app-delete-conversion>
